export default __webpack_public_path__ + "img/slide1-redesigned.6c86f1b2.png";